import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { RidButton } from '../../components/rid-button/rid-button';
import { RidDemoPage } from '../../components/rid-demo-page/rid-demo-page';

@Component({
  selector: 'app-mechanics-page',
  imports: [RouterLink, RidButton, RidDemoPage],
  templateUrl: './mechanics-page.html',
})
export class MechanicsPage {}
